<div *ngIf="(content$ | async) as appContent">
  <form [formGroup]="academicYearForm" ngxsForm="academicYearState.academicYearForm">
    <div class="nha-sa-section-header">
      <span>{{appContent.resourceStrings["nha.sa.schoolyearheader"]}}</span>
      <span class="nha-pattern-dots"></span>
    </div>
    <div class="nha-row">
      <legend id="academicYearQuestion" class="nha-gr-12">
        <span class="nha-required" aria-hidden="true">*</span> {{appContent.resourceStrings["nha.sa.schoolyearsubtext"]}}
      </legend>
      <fieldset class="nha-form-radio print-row">
        <div class="nha-gr-12">
          <div *ngIf="!isExternalEnroll(appContent.overrideCurrentAcademicYearEnroll)" class="nha-form-group nha-inline-block">
            <input id="currentAcademicYear" class="nha-input-radio" type="radio" formControlName="academicYearId"
              name="academicYearId" [value]="appContent.currentAcademicYear"
              aria-labelledby="academicYearQuestion currentAcademicYear"
              [attr.disabled]="isCurrentYearUnavailable(appContent.currentLastDayOfSchool) ? '' : null" aria-required="true"
              checked />
            <label for="currentAcademicYear">
              {{appContent.currentAcademicYear}}-{{appContent.currentAcademicYear + 1}}
              ({{appContent.resourceStrings["nha.sa.currentschoolyear"]}})
            </label>
            <div class="nha-form-error-desc">{{appContent.resourceStrings["nha.sa.errorselectschoolyear"]}}</div>
          </div>
          <div *ngIf="isExternalEnroll(appContent.overrideCurrentAcademicYearEnroll) && appContent.schoolID === 345" class="nha-form-group nha-inline-block" [innerHTML]="appContent.resourceStrings['nha.sa.enrollindy']"></div>
        </div>
        <div class="nha-gr-12">
          <div *ngIf="!isExternalEnroll(appContent.overrideNextAcademicYearEnroll)" class="nha-form-group nha-inline-block">
            <input id="nextAcademicYear" class="nha-input-radio" type="radio" formControlName="academicYearId"
              name="academicYearId" [value]="appContent.nextAcademicYear"
              aria-labelledby="academicYearQuestion nextAcademicYear"
              [attr.disabled]="today < convertToDate(appContent.nextOpenEnrollmentBeginDate) ? '' : null" />
            <label for="nextAcademicYear">
              {{appContent.nextAcademicYear}}-{{appContent.nextAcademicYear + 1}}
              ({{appContent.resourceStrings["nha.sa.nextschoolyear"]}})
              <span *ngIf="today < convertToDate(appContent.nextOpenEnrollmentBeginDate)"
                class="nha-warning-link nha-sa-ay-unavailable">
                <span class="fa fa-exclamation-circle"></span>
                <span>
                  {{appContent.resourceStrings["nha.sa.applystarting"]}}
                  {{appContent.nextOpenEnrollmentBeginDate | dotNetDate | date:'shortDate'}}
                </span>
              </span>
            </label>
            <span *ngIf="showLandingPageLink && landingPage !== ''">
              <a [href]="getFutureLandingPageURL()" target="_blank">Click here to receive a reminder when Open Enrollment begins</a>
          </span>
          </div>
          <div *ngIf="isExternalEnroll(appContent.overrideNextAcademicYearEnroll) && appContent.schoolID === 345" class="nha-form-group nha-inline-block" [innerHTML]="appContent.resourceStrings['nha.sa.enrollindy']"></div>
          <div *ngIf="isExternalEnroll(appContent.overrideNextAcademicYearEnroll) && appContent.schoolID === 326" class="nha-form-group nha-inline-block" [innerHTML]="appContent.resourceStrings['nha.sa.enrollbuffalo']"></div>
        </div>
      </fieldset>
    </div>
  </form>
</div>
